import { Heading, Stack, Text } from "@chakra-ui/react";

import Button from "components/Chakra/Button";
import IconSupportRedLp from "components/Chakra/Icons/SupportRedLp";

type BannerProps = {
  handleScrollToSection: () => void;
};

const Banner = ({ handleScrollToSection }: BannerProps) => (
  <Stack
    position="relative"
    p="20px"
    justify="center"
    align="center"
    textAlign="center"
    spacing="16px"
    boxShadow="0 2px 5px rgba(0, 0, 0, 0.2)"
    maxW="940px"
    margin="140px auto 56px"
  >
    <IconSupportRedLp position="absolute" top="-60px" boxSize="100px" />

    <Heading maxW="422px" fontSize="28px" pt="20px">
      Bezstarostný příjem z pronájmu
    </Heading>
    <Text maxW="420px" color="ud-primary" fontWeight={700} fontSize="28px">
      Ať se děje cokoliv...
    </Text>
    <Text maxW="550px" py="8px">
      Nechejte nám na sebe kontakt a my se vám do 24 hodin ozveme. Rádi s vámi{" "}
      <Text as="span" color="ud-black" fontWeight={700}>
        probereme vaše potřeby a představíme výhody naší služby.
      </Text>
    </Text>
    <Button borderRadius="full" w="fit-content" onClick={handleScrollToSection}>
      Domluvit schůzku
    </Button>
  </Stack>
);
export default Banner;
